import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

// prettier-ignore
// capitalize :: String -> String
const capitalize = R.converge(R.concat, [
  R.o(R.toUpper, R.head),
  R.o(R.toLower, R.tail)
])

const FilterChips = ({ filters, defaultState, onRemove }) => {
  const [appliedFilters, setAppliedFilters] = useState([]);

  useEffect(() => {
    const filterOut = ({ label, value }) => !R.equals(value, defaultState[R.toLower(label)]);

    R.compose(
      setAppliedFilters,
      R.filter(filterOut),
      R.map(R.applySpec({ label: R.o(capitalize, R.head), value: R.last })),
      R.toPairs
    )(filters);
  }, [filters, defaultState]);

  return (
    !R.isEmpty(appliedFilters) && (
      <Stack direction="row" spacing={1} sx={{ mr: 2, mt: 3 }}>
        {appliedFilters.map(item =>
          item.value ? (
            <FilterChip filter={item} key={`${item.label}-${item.value}`} removeFilter={onRemove} />
          ) : null
        )}
      </Stack>
    )
  );
};

FilterChips.propTypes = {
  defaultState: PropTypes.shape({}).isRequired,
  filters: PropTypes.shape({}),
  onRemove: PropTypes.func.isRequired,
};

FilterChips.defaultProps = {
  filters: {},
};

export default FilterChips;

// aux component 1
const FilterChip = ({ filter, removeFilter }) => (
  <Chip
    label={`${filter.label}: ${capitalize(filter.value)}`}
    onDelete={() => removeFilter(R.toLower(filter.label))}
    sx={{ borderColor: 'secondary.main', borderRadius: 25 }}
    variant="outlined"
  />
);

FilterChip.propTypes = {
  filter: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  }),
  removeFilter: PropTypes.func.isRequired,
};

FilterChip.defaultProps = {
  filter: { label: '', value: '' },
};

// aux component 2
const FilterCountChip = ({ count }) => (
  <Box
    sx={{
      alignItems: 'center',
      backgroundColor: 'primary.light',
      borderRadius: '2px',
      display: 'flex',
      flexDirection: 'column',
      height: '20px',
      justifyContent: 'center',
      ml: 1,
      mr: '6px',
      width: '15px',
    }}
  >
    <Typography variant="caption">{count}</Typography>
  </Box>
);

FilterCountChip.propTypes = {
  count: PropTypes.number.isRequired,
};

export { FilterCountChip };
